import React, { useContext } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import useUnauthorized from 'hooks/useUnauthorized';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import FourDotLoader from 'components/FourDotLoader';
import EnterpriseProvider from './providers/Enterprise';
import { useLockScrollOnParamsReroute } from 'hooks/useLockScrollOnParamsReroute';
import EnterpriseHeader from './components/EnterpriseHeader';
import EnterpriseContext from './providers/Enterprise/Enterprise.context';

import './Enterprise.styles.scss';
import './Enterprise.styles.responsive.scss';

const EnterpriseWrapper: React.FC = () => {
  const { enterprise } = useContext(EnterpriseContext);

  return (
    <>
      <EnterpriseHeader enterprise={enterprise} />
      <Outlet />
    </>
  );
};

const EnterpriseRouter: React.FC = () => {
  const { isSuperAdmin, isEnterpriseHead, isOfficeManager, enterprise } =
    useContext(CurrentUserContext);

  const { id } = useParams();

  useLockScrollOnParamsReroute();

  const { isAuthorizing } = useUnauthorized(
    isSuperAdmin ||
      ((isEnterpriseHead || isOfficeManager) && id === enterprise?._id),
  );

  if (isAuthorizing) return <FourDotLoader />;

  return (
    <div className="enterprise">
      <EnterpriseProvider>
        <EnterpriseWrapper />
      </EnterpriseProvider>
    </div>
  );
};

export default EnterpriseRouter;
